var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/InvestmentAllocationConstants');
var ApplicationConstants = require('../constants/ApplicationConstants');
var PortfolioRebateConstants = require('../constants/PortfolioRebateConstants');
var PensionPaymentConstants = require('../constants/PensionPaymentConstants');
var AutoRebalancingConstants = require('../constants/AutoRebalancingConstants');
var PensionConstants = require('../constants/PensionTypeConstants.js');
var EventEmitter = require('events').EventEmitter;
var assign = require('object-assign');
var _ = require('lodash');
var Immutable = require('immutable');
var Content = require('../services/ContentService');
var ActionTypes = Constants.ActionTypes;
var ErrorCodes = ApplicationConstants.ErrorCodes;
var ValidationTypes = ApplicationConstants.ValidationTypes;
var Products = require('../utils/Products');
var Formatter = require('../utils/Formatter');
import {getAssetAllocationsList} from '../apis/AssetAllocationsAPI.js';
var CHANGE_EVENT = 'change';

var _investmentListAvailable = true;

var _list = [];
var _removedList = [];
var _isHideError = true;
var _isHideAcknowledgementError = true;
var _errorCode = null, _validationType = null;
var _totalQty = 0;
var _termDepositMessage = true;
var _selectedTerm = ApplicationConstants.YesNoValues.NO;
var _isAllocationSaved = false;
var _isInvestmentAllocationLimit = false;
var _withNonZeroValue = false;
var _productId;
var _validationSummary = Immutable.List.of([]);
var _hideSectionDueToInSpecieSection = false;
var _hideSectionDueToPensionType = true;
var _crossSectionDependencyMsg = [];
var _portfolioRebateData;
var _pensionPaymentDrawDownOption;
var _autoRebalancingOption;
var _ripModel;
var _isInvestmentAllocationAcknowledged = false;
var _isFirstRateCashNonAutoRebalancing = ApplicationConstants.YesNoValues.NO;
var _pensionType;

let _memberAttestationModel = {
   attestation: ''
}

// Method to load allocated investment options
function loadAllocatedInvestmentOptions(list) {
    _list = list;
}

function checkInvestmentAllocationLimitExceed() {
    if (_list.length >= 95) {
        _isInvestmentAllocationLimit = true;
    }
    else {
        _isInvestmentAllocationLimit = false;
    }
}

function getAssetAllocation() {
    const allInvestmentOptionIds = _.pluck(_list, 'id');
    if (allInvestmentOptionIds && allInvestmentOptionIds.length > 0) {
        getAssetAllocationsList(_productId, allInvestmentOptionIds, false);
    }
}

// Method to add investment option to investment allocation table
function addInvestmentOptions(investmentOptions) {
    _.forEach(investmentOptions, function (n) {
        if(!_list.some(x => x.id == n.id))
        {
            if(_isFirstRateCashNonAutoRebalancing === ApplicationConstants.YesNoValues.YES && n.isManagedAccountOrModelPortfolio)
                n.disabled = true;

            _list.push(n);
        }
    });
    _isAllocationSaved = false;
    checkInvestmentAllocationLimitExceed();
    _crossSectionDependencyMsg = [];
    var portfolioRebateOption = _.get(_portfolioRebateData, 'portfolioRebateData.portfolioRebateOption');
    if (portfolioRebateOption === PortfolioRebateConstants.PortfolioRebateValues.SELECT_OPTION && investmentOptions[investmentOptions.length-1].rebatePaymentOption) {
        var portfolioHeader = Products.isInvestment(_productId) ? Content.getContent().crossSectionHeaders.managementCostRebate : Content.getContent().crossSectionHeaders.portfolioRebate;
        _crossSectionDependencyMsg.push({content: portfolioHeader, order: 4});
    }
    if (_pensionPaymentDrawDownOption === PensionPaymentConstants.DrawDownOption.CUSTOM && investmentOptions.length) {
        _crossSectionDependencyMsg.push({content: Content.getContent().crossSectionHeaders.pensionPayment, order: 2});
    }
    toggleInvestmentMessage();
    getAssetAllocation();
    enableAllOptions();
    applyFirstRateCashAutoRebalancing();   
}

// Method to remove investment option from investment allocation table
function removeInvestmentOption(investmentOptions) {    
    
    if(investmentOptions.isManagedAccountOrModelPortfolio) {
        _list.forEach(x => { 
            x.disabled = false;
            x.isManagedAccountOrModelPortfolio = false;
        }); 
    }
    
    _isAllocationSaved = false;
    _removedList.push(investmentOptions); //adding the investment option search
    _.remove(_list, { id: investmentOptions.id }); //removing investment list table    
    clearTable();
    checkInvestmentAllocationLimitExceed();
    _crossSectionDependencyMsg = [];
    if (investmentOptions.rebatePaymentOption && _portfolioRebateData.portfolioRebateData.portfolioRebateOption === PortfolioRebateConstants.PortfolioRebateValues.SELECT_OPTION) {
        var portfolioHeader = Products.isInvestment(_productId) ? Content.getContent().crossSectionHeaders.managementCostRebate : Content.getContent().crossSectionHeaders.portfolioRebate;
        _crossSectionDependencyMsg.push({content: portfolioHeader, order: 4});
    }
    if (_pensionPaymentDrawDownOption === PensionPaymentConstants.DrawDownOption.CUSTOM) {
        _crossSectionDependencyMsg.push({content: Content.getContent().crossSectionHeaders.pensionPayment, order: 2});
    }
    toggleInvestmentMessage();
    getAssetAllocation();
    applyFirstRateCashAutoRebalancing();

    if(_isFirstRateCashNonAutoRebalancing === ApplicationConstants.YesNoValues.YES && !_list.some(x => x.cashOption === true))
        toggleFirstRateCashNonAutoRebalancingOption(ApplicationConstants.YesNoValues.NO);    
}

function toggleInvestmentMessage() {
    if (ApplicationConstants.FormModel.form.regularInvestmentPlan.ripOption === ApplicationConstants.YesNoValues.YES) {
        _crossSectionDependencyMsg.push({content: Content.getContent().crossSectionHeaders.regularInvestmentPlan, order: 1});
    }
    

    if (_autoRebalancingOption === ApplicationConstants.YesNoValues.YES) {
        _crossSectionDependencyMsg.push({content: Content.getContent().crossSectionHeaders.autoRebalancing, order: 3});
    }
}

function clearTable() {
    if (_list.length < 1)
        _investmentListAvailable = true;
    else
        _investmentListAvailable = false;
    return _investmentListAvailable;
}

// Method to update investment option in investment allocation table
function updateInvestmentOption(investmentOption, index) {
    _list[index].weight = investmentOption;
    _isAllocationSaved = false;
   
    applyFirstRateCashAutoRebalancing();

    if (_ripModel && _ripModel.sameAsInvestAllocationOption === ApplicationConstants.YesNoValues.YES) {
        _crossSectionDependencyMsg = [];
        _crossSectionDependencyMsg.push({content: Content.getContent().crossSectionHeaders.regularInvestmentPlan, order: 1});
    }
}

function applyFirstRateCashAutoRebalancing() {

    if(_isFirstRateCashNonAutoRebalancing !== ApplicationConstants.YesNoValues.YES || !_list.length) return;

    const nonManagedAccountWeight = _list.filter(x => !x.isManagedAccountOrModelPortfolio).map(x => !x.weight ? 0 : parseFloat(x.weight));
    const nonManagedAccountPercentage = +nonManagedAccountWeight.reduce((x, y) => x+y, 0).toFixed(2) / 100;
    const managedAccountOptions = _list.filter(x => x.isManagedAccountOrModelPortfolio && (+x.weight > 0 || x.originalWeight > 0));

    if(managedAccountOptions.length == 0) return;

    managedAccountOptions.forEach(x => {
        
        if(!x.originalWeight) x.originalWeight = +x.weight;
        
        x.weight = nonManagedAccountPercentage === 0 ? x.originalWeight.toFixed(2) : (x.originalWeight - (x.originalWeight * nonManagedAccountPercentage)).toFixed(2);

        if(+x.weight < 0) x.weight = '0.00';

    });

    const totalAllocation = +(_list.map(x => +x.weight).reduce((x, y) => x+y, 0)).toFixed(2);
    const mostConservativeOption = _list.filter(x => x.isManagedAccountOrModelPortfolio).sort((x, y) => x.redemptionSequenceNumber - y.redemptionSequenceNumber)[0];

    if(mostConservativeOption && nonManagedAccountPercentage) {
        
        if(totalAllocation > 100) {
            const amountToReduce = (totalAllocation - 100)
            const recalculatedWeight = (+mostConservativeOption.weight - amountToReduce);
            mostConservativeOption.weight = (recalculatedWeight < 0 ? 0 : recalculatedWeight).toFixed(2);
        }
        else if(totalAllocation < 100) {
            const amountToIncrease = (100 - totalAllocation);
            mostConservativeOption.weight = (+mostConservativeOption.weight + amountToIncrease).toFixed(2);
        }
    }
}

// Method to clear table from investment allocation table during model portfolio change
function clearInvestmentOptions(pensionTypeChanged = false) {
    _isAllocationSaved = false;
    _.forEach(_list, function (n) {
        if((_isFirstRateCashNonAutoRebalancing !== ApplicationConstants.YesNoValues.YES || !n.cashOption || pensionTypeChanged) && !_removedList.some(x => x.id === n.id))
            _removedList.push(n);
    });
    _list = _isFirstRateCashNonAutoRebalancing !== ApplicationConstants.YesNoValues.YES || pensionTypeChanged ? [] : _list.filter(x => x.cashOption === true);
    _isInvestmentAllocationLimit = false;
}

function showValidation(showvalidation) {
    if (showvalidation && !validationError()) {
        _isAllocationSaved = true;
    }
}

function updateInvestmentAllocationAcknowledgement(isAcknowledged){
    _memberAttestationModel['attestation'] = isAcknowledged? 'Y': 'N';
    _isInvestmentAllocationAcknowledged = isAcknowledged;
}

function validationError() {
    if (_hideSectionDueToInSpecieSection) {
        _errorCode = null;
        return false;
    }

    if (_list.length) {
        if (_totalQty !== 100) {
            _errorCode = ErrorCodes.TotalIsNot100;
            _isHideError = false;
            _validationType = ValidationTypes.Warning;
            return true;
        } else {
            validateNoneZeroValue(); // crawl to search with zero value

            if (_withNonZeroValue) {
                _errorCode = ErrorCodes.WithNonZeroValue;
                _isHideError = false;
                _validationType = ValidationTypes.Warning;
                return true;
            } else {
                _errorCode = ErrorCodes.Diversification;
                _isHideError = false;
                _validationType = ValidationTypes.Primary;
                return false;
            }
        }
    } else {
        _errorCode = ErrorCodes.AtLeastOne;
        _isHideError = false;
        _validationType = ValidationTypes.Warning;
        return true;
    }
}

function validateInvestmentAllocations() {

    if (_productId && !Products.isAnnuity(_productId)) {
        validationError();
        var errors = [];
        var copyText = Content.getContent().investmentAllocation;

        switch(_errorCode) {
            case ErrorCodes.AtLeastOne:
            case ErrorCodes.TotalIsNot100:
                errors.push({ message: copyText.totalMustBe100RequiredErrorHeading, clickable: copyText.sectionHeader, id: 'investment-allocation' });
                break;
            case ErrorCodes.WithNonZeroValue:
                errors.push({ message: copyText.mustHaveNoZeroValueRequiredErrorHeading, clickable: copyText.sectionHeader, id: 'investment-allocation' });
                break;
            default:
                break;
        }
        
        let user = window.NOA.userContext;
        if (!user || user.isInvestor && (!_isInvestmentAllocationAcknowledged && !_hideSectionDueToInSpecieSection)) {
            errors.push({ message: 'Acknowledgement is required', clickable: copyText.sectionHeader, id: 'acknowledgementSection' });
            _isHideAcknowledgementError = false;
        }

        if (errors.length > 0) {
            _validationSummary = Immutable.List.of(errors);
        }
        else {
            _validationSummary = Immutable.List.of([]);
        }
    }
}

// Get consolidate contributions for term deposit - if yes/no
function selectConsolidateContributionsForTermDeposits(value) {
    _selectedTerm = value;
}

function validateNoneZeroValue() {
    var hasZeroPercentage = false;
    if (_list.length > 0) {
        _.forEach(_list, function (n) {
            if (n.weight == '0.00') {
                hasZeroPercentage = true;
            }
        })
        _withNonZeroValue = hasZeroPercentage;
    }
}

function setProductId(productId) {
    _productId = productId;

    if(_productId != ApplicationConstants.ProductIds.PENSION)
        _isFirstRateCashNonAutoRebalancing = ApplicationConstants.YesNoValues.NO;    
}

function toggleFirstRateCashNonAutoRebalancingOption(value) {
    _isFirstRateCashNonAutoRebalancing = value;

    if(value === ApplicationConstants.YesNoValues.NO) {
        _list.forEach(x => {
            x.disabled = false;
            x.isManagedAccountOrModelPortfolio = false;                
        });
    }
    else {
        _list.forEach(x => {
            x.disabled = x.isManagedAccountOrModelPortfolio;
        });
    }

}

function enableAllOptions() {
    const hasIndividualInvestmentOptions = _list.some(x => !x.cashOption && !x.isManagedAccountOrModelPortfolio);

    if(hasIndividualInvestmentOptions) {
        _list.forEach(x => {
            if(x.disabled) {
                x.disabled = false;
                x.isManagedAccountOrModelPortfolio = false;
            }
        });
    }
}

function setInSpecieDecisions(toHideSection) {
    if (_hideSectionDueToInSpecieSection !== toHideSection) {
        if (toHideSection) {
            // to hide section, clean up inv option list and cross dep message
            clearInvestmentOptions();
            _investmentListAvailable = true;
            _crossSectionDependencyMsg = [];
        } else {
            // to show section, clean up error which may be produced by states before hidden or confirm/review
            _withNonZeroValue = false;
            _validationSummary = Immutable.List.of([]);
            _isHideError = true;
            _errorCode = null;
            _validationType = null;
        }
    }
    _hideSectionDueToInSpecieSection = toHideSection;
}

function setPensionTypeSelected(selectedPensionType) {
    const previousPensionType = _pensionType;
    _pensionType = selectedPensionType;
    _hideSectionDueToPensionType = selectedPensionType == null

    if(previousPensionType && previousPensionType !== _pensionType) {
        _isFirstRateCashNonAutoRebalancing = ApplicationConstants.YesNoValues.NO;
        clearInvestmentOptions(true); 
    }
}

function setPortfolioRebate(portfolioRebateData) {
    _portfolioRebateData = _.cloneDeep(portfolioRebateData);
}

function setPensionPaymentDrawDownOption(drawDownOption) {
    _pensionPaymentDrawDownOption = drawDownOption;
}

function setAutoRebalancing(data) {
    if (data.changedField === AutoRebalancingConstants.AutoRebalancingFields.AUTO_REBALANCING_OPTIONS) {
        _autoRebalancingOption = data.option.value;
    }
}

function setRipModel(ripModel) {
    _ripModel = _.cloneDeep(ripModel);
}

function sortCrossSectionOrder() {
    _crossSectionDependencyMsg = _.sortBy(_crossSectionDependencyMsg, 'order');
}

function retrieveCrossSection(form) {
    if (form) {
        _crossSectionDependencyMsg = [];
        _portfolioRebateData = { portfolioRebateData: _.cloneDeep(form.portfolioRebate) };
        _pensionPaymentDrawDownOption = form.pensionPayment? form.pensionPayment.drawDownOption || '' : '';
        _autoRebalancingOption = form.autoRebalancing ? form.autoRebalancing.setAutoRebalancing || '' : '';
    }
}

var InvestmentAllocationStore = assign({}, EventEmitter.prototype, {

    emitChange: function () {
        this.emit(CHANGE_EVENT);
    },

    /**
     * @param {function} callback
     */
    addChangeListener: function (callback) {
        this.on(CHANGE_EVENT, callback);
    },

    /**
     * @param {function} callback
     */
    removeChangeListener: function (callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },

    // Return Investment Option list
    getList: function () {
        return _.cloneDeep(_list);
    },

    investmentListAvailable: function () {
        if (_list.length > 0)
            _investmentListAvailable = false;
        else
            _investmentListAvailable = true;
        return _investmentListAvailable;
    },

    getTotal: function () {

        var total = 0;

        for (var list in _list) {
            total += parseFloat(_list[list].weight == '' ? 0 : _list[list].weight);
            if (isNaN(total)) {
                total = 0;
            }
        }
        total = Formatter.roundToTwo(total);
        _totalQty = total;

        if (total >= 100) {
            validationError();
        } else {
            if (_errorCode === ErrorCodes.WithNonZeroValue) {
                validateNoneZeroValue();

                if (_withNonZeroValue) {
                    _errorCode = ErrorCodes.WithNonZeroValue;
                    _validationType = ValidationTypes.Warning;
                } else {
                    _errorCode = ErrorCodes.Diversification;
                    _validationType = ValidationTypes.Primary;
                }
                _isHideError = false;
            }
        }

        if (_list.length < 1 && _errorCode !== ErrorCodes.AtLeastOne) {
            _isHideError = true;
        }

        total = total.toFixed(2);
        return total;
    },

    getValidationError: function () {
        return _errorCode;
    },

    getValidationType: function () {
        return _validationType;
    },

    isHideError: function () {
        return _isHideError;
    },  

    getRemovedItems: function () {
        return _removedList;
    },
    
    isInvestmentAllocationAcknowledged: function () {
        return _isInvestmentAllocationAcknowledged;
    },

    getMemberAttestationModel: function(){
        return _memberAttestationModel;
    },

    isHideAcknowledgementError: function(){
        return _isHideAcknowledgementError;
    },

    isHideAcknowledgementSection : function(){
        let user = window.NOA.userContext;

        if(!user || user.isInvestor && !Products.isAnnuity(_productId))
        {
            return false;
        }
        return true;
    },

    clearInvestmentSearch: function () {
        _removedList = [];
    },

    termDepositMessage: function () {

        var test = _.find(_list, { termDeposit: true });

        if (test != null)
            _termDepositMessage = false;
        else
            _termDepositMessage = true;

        return _termDepositMessage;
    },

    isConsolidateTermDeposit: function () {
        if (_termDepositMessage) {
            _selectedTerm = ApplicationConstants.YesNoValues.NO;
        }
        return _selectedTerm;
    },

    isAllocationSaved: function () {
        return _isAllocationSaved;
    },

    getIsInvestmentAllocationLimit: function () {
        return _isInvestmentAllocationLimit;
    },

    getInvestmentAllocationData: function () {
        var formModel = {
            ModelPortfolioId: '',
            consolidateContributionsForTermDeposits: '',
            investmentOptions: []
        }
        formModel.consolidateContributionsForTermDeposits = _selectedTerm;
        if (_list.length > 0) {
            _.forEach(_list, function (n) {
                formModel.investmentOptions.push({ 
                    id: n.id, 
                    code: n.code, 
                    name: n.name, 
                    weight: n.weight, 
                    termDeposit: n.termDeposit, 
                    fmsCode: n.fmsCode, 
                    rebatePaymentOption: n.rebatePaymentOption, 
                    redemptionSequenceNumber: n.redemptionSequenceNumber, 
                    groupSequenceNumber: n.groupSequenceNumber, 
                    isFirstRateInvestment: n.isFirstRateInvestment, 
                    preRetirementIndicator: n.preRetirementIndicator, 
                    isManagedAccountOrModelPortfolio : n.isManagedAccountOrModelPortfolio,  
                    originalWeight : n.originalWeight  
                });
            });
        }
        return formModel;
    },

    getErrorList: function () {
        return _validationSummary;
    },
    getHideSectionDueToInSpecieOrPensionType: function() {
        return _hideSectionDueToInSpecieSection || (_hideSectionDueToPensionType && _productId === ApplicationConstants.ProductIds.PENSION);
    },
    getCrossSectionDependencyMsg: function () {
        sortCrossSectionOrder();
        return _crossSectionDependencyMsg;
    },
    showFirstRateCashNonAutoRebalancing : function () {
        return window.NOA != null && window.NOA.userContext.isAdviser && (_productId == ApplicationConstants.ProductIds.PENSION || _productId == ApplicationConstants.ProductIds.INVESTMENT || _productId == ApplicationConstants.ProductIds.SUPER);
    },
    getFirstRateCashNonAutoRebalancing : function () {
        return _isFirstRateCashNonAutoRebalancing;
    },
    isAssetAllocationVisible: function() {
        return _pensionType === PensionConstants.PensionTypeSelectionNames.PRE_RETIREMENT || _isFirstRateCashNonAutoRebalancing === ApplicationConstants.YesNoValues.NO 
        || (_isFirstRateCashNonAutoRebalancing === ApplicationConstants.YesNoValues.YES && _list.some(x => x.termDeposit === true || x.id == Constants.FirstRateSaverNonAutoRebalancing || x.id == Constants.FirstRateCashNonAutoRebalancing || x.id == Constants.FirstRateTTRSaverNonAutoRebalancing));
    },
    areCashOptionsVisible: function() {
        return _isFirstRateCashNonAutoRebalancing === ApplicationConstants.YesNoValues.YES;
    }
});

InvestmentAllocationStore.dispatchToken = AppDispatcher.register(function (action) {

    switch (action.actionType) {

        case ActionTypes.RECEIVE_ALLOCATED_INVESTMENT_OPTIONS:
            loadAllocatedInvestmentOptions(action.allocatedInvestmentOptions);
            break;

        case ActionTypes.ADD_INVESTMENT_OPTION:
            addInvestmentOptions(action.investmentOptions);
            break;

        case ActionTypes.REMOVE_INVESTMENT_OPTION:
            removeInvestmentOption(action.investmentOption);
            break;

        case ActionTypes.UPDATE_INVESTMENT_OPTION:
            updateInvestmentOption(action.investmentOption, action.index);
            break;

        case ActionTypes.CLEAR_INVESTMENT_OPTIONS:
            clearInvestmentOptions();
            break;

        case ActionTypes.SHOW_VALIDATION:
            showValidation(action.showvalidation);
            break;

        case ActionTypes.SELECT_CONSOLIDATE_TERM_DEPOSIT:
            selectConsolidateContributionsForTermDeposits(action.value);
            break;
        case ActionTypes.UPDATE_INVESTMENT_ALLOCATION_ACKNOWLEDGEMENT:
            updateInvestmentAllocationAcknowledgement(action.isAcknowledged)
            break;
        case ApplicationConstants.ActionTypes.NEW_APPLICATION_INITIALISED:
            setProductId(action.productId);
            break;

        case ApplicationConstants.ActionTypes.APPLICATION_RETRIEVE_SUCCESS:
            const form = action.applicationData.form;
            setProductId(action.applicationData.productId);
            setPensionTypeSelected(form && form.pensionType ? form.pensionType.selectedPensionType : null)   
            const isFirstRateCashNonAutoRebalancing = form && form.investmentAllocation && form.investmentAllocation.isFirstRateCashNonAutoRebalancing ? form.investmentAllocation.isFirstRateCashNonAutoRebalancing : ApplicationConstants.YesNoValues.NO;         
            toggleFirstRateCashNonAutoRebalancingOption(isFirstRateCashNonAutoRebalancing);
            
            var investmentAllocation = _.get(action, 'applicationData.form.investmentAllocation');
            if (investmentAllocation) {
                var selectedTerm = investmentAllocation.consolidateContributionsForTermDeposits;
                selectConsolidateContributionsForTermDeposits(selectedTerm);
                retrieveCrossSection(action.applicationData.form);
            }
            break;

        case ApplicationConstants.ActionTypes.VALIDATE_APPLICATION:
            validateInvestmentAllocations();
            break;

        case ApplicationConstants.ActionTypes.SEND_INSPECIE_DECISIONS:
            setInSpecieDecisions(action.data);
            break;
        
        case PensionConstants.ActionTypes.SELECT_PENSION_TYPE:
            setPensionTypeSelected(action.value);
            break;

        case ApplicationConstants.ActionTypes.SEND_PORTFOLIO_REBATE_DETAILS:
            setPortfolioRebate(action.portfolioRebateData);
            break;

        case ApplicationConstants.ActionTypes.SEND_PENSION_PAYMENT_DRAW_DOWN_OPTION:
            setPensionPaymentDrawDownOption(action.drawDownOption);
            break;

        case AutoRebalancingConstants.ActionTypes.UPDATE_AUTO_REBALANCING:
            setAutoRebalancing(action.data);
            break;

        case ApplicationConstants.ActionTypes.SEND_RIP_MODEL:
            setRipModel(action.model);
            break;
        case ApplicationConstants.ActionTypes.SEND_YOUR_DETAIL_DOB:
            clearInvestmentOptions();
            break;
        case ActionTypes.TOGGLE_FIRST_RATE_CASH_NON_AUTO_REBALANCING:
            toggleFirstRateCashNonAutoRebalancingOption(action.value);
            break;
        case ActionTypes.REMOVE_SELECTED_PORTFOLIO_LIST:
            enableAllOptions();
            break;
        default:
            return true;
    }

    // If action was responded to, emit change event
    InvestmentAllocationStore.emitChange();
    return true;

});

module.exports = InvestmentAllocationStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/InvestmentAllocationStore.js